import api from "./api";
import type { TenantNotification } from "@/mocks/notifications";

function unwrapNotificationList(value: unknown): TenantNotification[] {
  if (Array.isArray(value)) return value as TenantNotification[];
  if (value && typeof value === "object") {
    const data = (value as { data?: unknown }).data;
    if (Array.isArray(data)) return data as TenantNotification[];
  }
  return [];
}

function unwrapUnreadCount(value: unknown): { count: number } {
  const payload =
    value && typeof value === "object" && "data" in value
      ? (value as { data?: unknown }).data
      : value;

  if (payload && typeof payload === "object") {
    const raw =
      (payload as { count?: unknown; unread_count?: unknown }).count ??
      (payload as { unread_count?: unknown }).unread_count;
    const count = Number(raw ?? 0);
    return { count: Number.isFinite(count) ? count : 0 };
  }

  const count = Number(payload ?? 0);
  return { count: Number.isFinite(count) ? count : 0 };
}

export const notificationService = {
  /**
   * `scope: 'mine'` bỏ tin phát chung, chỉ lấy tin gửi đích danh (TCR-1521, màn 8).
   *
   * Chuông trên web muốn cả hai. App người giao thì không: tenant đang có ~786 tin
   * phát chung trên tổng 799, mà máy chủ cắt ở 50 tin mới nhất — tin gửi riêng cho
   * người giao bị đẩy khỏi danh sách gần như ngay lập tức.
   */
  list: (scope?: 'mine') =>
    api
      .get<unknown>("/notifications", scope ? { params: { scope } } : undefined)
      .then((r) => unwrapNotificationList(r.data)),
  unreadCount: (scope?: 'mine') =>
    api
      .get<unknown>("/notifications/unread-count", scope ? { params: { scope } } : undefined)
      .then((r) => unwrapUnreadCount(r.data)),
  markRead: (id: string) =>
    api.patch<{ ok: true }>(`/notifications/${id}/read`).then((r) => r.data),
  markAllRead: (scope?: 'mine') =>
    api
      .patch<{ ok: true }>("/notifications/read-all", undefined, scope ? { params: { scope } } : undefined)
      .then((r) => r.data),
};
